const routes = {
  '/rover': {
    fetch: () =>
      Promise.all([
        import(/* webpackChunkName: 'rover-route' */ 'app/rover/asyncRoute'),
      ]).then(([module]) => module.default),
  },
};

export default routes;
